/* @ngInject */
function HomeTemplatesController ($q, $scope, $state, $timeout, HomeService, SegmentService, AssetPreviewService) {
  $scope.countHomeTemplate = 7

  const api = {
    _handleSuccessGetTemplates,
    _getPreviewAssets
  }
  this.getApi = () => api

  activate()

  function activate () {
    HomeService.getHomeTemplates($scope.countHomeTemplate).then(api._handleSuccessGetTemplates)
  }

  function _handleSuccessGetTemplates (templates) {
    $scope.templates = templates?.rows ?? []
  }

  $scope.openPreview = index => {
    const art = $scope.templates[index]

    SegmentService.track('arts-widget-file-view')
    AssetPreviewService.openAssetPreview({
      asset: art,
      getPreviewAssets: api._getPreviewAssets
    })
  }

  function _getPreviewAssets () {
    const deferred = $q.defer()
    $timeout(() => {
      deferred.resolve({
        assets: $scope.templates,
        count: $scope.templates.length
      })
    }, 100, true)
    return deferred.promise
  }

  $scope.goToArtsClick = function () {
    $state.go('arts.templates')
    SegmentService.track('arts-widget-file-all')
  }
}

export { HomeTemplatesController }
